module.exports = new __parcel__URL__("aristoteles.0c0b5b4e.png").toString();